<div class="input-password">
  <span
    class="input-password__prefix"
    [class.input-password__prefix--error]="hasError"
    aria-hidden="true"
  >
    <svg
      class="input-password__prefix-icon"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 10V8.25C8.5 6.17893 10.1789 4.5 12.25 4.5C14.3211 4.5 16 6.17893 16 8.25V10"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="6"
        y="10"
        width="12.5"
        height="9.5"
        rx="2.5"
        stroke="currentColor"
        stroke-width="1.8"
      />
      <circle
        cx="12.25"
        cy="14.75"
        r="1"
        fill="currentColor"
      />
    </svg>
  </span>

  @if (formControl) {
    <input
      class="input-password__field"
      [class.input-password__field--error]="hasError"
      [id]="id"
      [type]="inputType"
      [placeholder]="placeholder"
      [formControl]="formControl"
      [disabled]="disabled"
      (blur)="onBlur()"
    />
  } @else {
    <input
      class="input-password__field"
      [class.input-password__field--error]="hasError"
      [id]="id"
      [type]="inputType"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (blur)="onBlur()"
    />
  }

  <button
    class="input-password__toggle"
    [class.input-password__toggle--error]="hasError"
    type="button"
    [disabled]="disabled"
    [attr.aria-label]="hidePassword ? 'Mostrar senha' : 'Ocultar senha'"
    [attr.aria-pressed]="!hidePassword"
    (click)="togglePasswordVisibility()"
  >
    @if (hidePassword) {
      <svg
        class="input-password__toggle-icon"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M2 12C3.8 8.4 7.4 6 12 6C16.6 6 20.2 8.4 22 12C20.2 15.6 16.6 18 12 18C7.4 18 3.8 15.6 2 12Z"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle
          cx="12"
          cy="12"
          r="3"
          stroke="currentColor"
          stroke-width="1.8"
        />
      </svg>
    } @else {
      <svg
        class="input-password__toggle-icon"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M3 3L21 21"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.6 10.7C10.2 11.1 10 11.5 10 12C10 13.1 10.9 14 12 14C12.5 14 12.9 13.8 13.3 13.4"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.7 6.8C5 8 3.7 9.7 2.9 12C4.7 15.6 8.3 18 12.9 18C14.8 18 16.6 17.6 18.1 16.8"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.9 6.2C10.6 6.1 11.3 6 12 6C16.6 6 20.2 8.4 22 12C21.4 13.2 20.7 14.2 19.8 15.1"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
  </button>
</div>